import {
	handleActions
} from 'redux-actions';
import Immutable from 'immutable';

const OrderDetailListState = Immutable.fromJS({
	orderId: '',
	orderDetailList: []
});

const orderDetailListReducer = handleActions({

	FIND_ORDER_DETAIL_LIST: (state, { payload }) => {
		return state.merge({
			orderDetailList: payload.data
		})
	},
	CLOSE_ORDER_MODAL: (state, { payload }) => {
		return state.merge({
			orderDetailList: []
		})
	}
}, OrderDetailListState);

export default orderDetailListReducer;


// WEBPACK FOOTER //
// ./src/reducers/orderDetailListReducer.js